<form #form="ngForm" (ngSubmit)="onSubmit()">
  @if (!user) {
    <div class="row form-group">
      <div class="col">
        @if (showLabels) {
          <label for="author" class="form-label">{{ 'Your Name' | messageTranslate }}:</label>
        }
        <input id="author" name="author" #authorInput="ngModel" [(ngModel)]="author" class="form-control"
          type="text" placeholder="{{ 'Your Name' | messageTranslate }}" required>
        @if (showErrors) {
          <app-errors [control]="authorInput"/>
        }
      </div>
    </div>
  }

  <div class="row">
    <div class="col">
      @if (showLabels) {
        <label for="commentText" class="form-label">{{ placeholder ?? (isCreate ? 'Add Comment' : 'Edit Comment' | messageTranslate) }}:</label>
      }
      <textarea #commentBox id="commentText" name="commentText" #commentTextInput="ngModel" [(ngModel)]="commentText" class="form-control"
        [rows]="rows" [placeholder]="placeholder ?? (isCreate ? 'Add Comment' : 'Edit Comment' | messageTranslate)"
        (focus)="emitFocusEvent(true)" (blur)="emitFocusEvent(false)" [required]="requireComment"
        appCommentMention [mentionListTemplate]="itemTemplate" [assigneesByEntityName]="assigneesByEntityName"
        [disableMentions]="disableMentions" [mentionsLoading]="assigneesLoading"></textarea>
      @if (showErrors) {
        <app-errors [control]="commentTextInput"/>
      }
    </div>
  </div>
</form>
<ng-template #itemTemplate let-item="item">
  @if (item.isSpinner) {
    <div class="px-2 py-2 text-center" (mousedown)="itemElementClickHandler(item, $event)">
      <fa-icon [appShowFaSpinner]="true"/>
    </div>
  } @else {
    <div [title]="item.label"
         [class]="'py-2 text-truncate ' + (item.isGroup ? 'px-3 bg-white text-body-secondary is-group' : 'clickable px-4')"
         (mousedown)="itemElementClickHandler(item, $event)">
      {{ item.label }}
    </div>
  }
</ng-template>
